import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
registerLocale('es', es)
import 'react-datepicker/dist/react-datepicker.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-regular-svg-icons'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import Selector from '../../../../components/Selector/Selector'
import useButtonSelector from '../../../../utils/hooks/useButtonSelector/useButtonSelector'

const options = [
  {
    id: 0,
    value: 'excel',
    label: 'Excel',
  },
]

export default function DailyRefills() {
  const { selected, onSelectedChange } = useButtonSelector(options)
  const [startDate, setStartDate] = useState(new Date())
  const [nnData, setNNData] = useState(null)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const handleGetNNData = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .dailyEmployeeRefillsReport(
        startDate.getMonth() + 1,
        startDate.getFullYear(),
      )
      .then((res) => {
        handleCLoseLoading()
        setNNData(res.data)
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  const handleGetReport = async () => {
    if (!selected) return

    const extension = selected.value === 'pdf' ? 'pdf' : 'xlsx'

    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .dailyEmployeeRefillsExport(
        startDate.getMonth() + 1,
        startDate.getFullYear(),
        selected.value,
      )
      .then((res) => {
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `Informe_de_recargas_diarias_por_colaborador.${extension}`,
        )
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="body2">Seleccione Fecha</Text>
          <HStack>
            <FontAwesomeIcon icon={faCalendar} />
            <Box border="1px solid #D7D7D7">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                showTwoColumnMonthYearPicker
                maxDate={new Date()}
                locale="es"
              />
            </Box>
          </HStack>
        </VStack>
        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetNNData}>
            Buscar
          </Button>
        </VStack>
      </HStack>
      {nnData && (
        <HStack alignItems="flex-end" paddingTop={5}>
          <VStack alignItems="flex-start">
            <Text variant="body2" fontWeight="bold">
              Descargar en formato
            </Text>
            <Box w="200px">
              <Selector
                isClearable
                options={options}
                placeholder="Opciones"
                onChange={onSelectedChange}
              />
            </Box>
          </VStack>
          <VStack paddingStart={5}>
            <Button onClick={handleGetReport}>Descargar informe</Button>
          </VStack>
        </HStack>
      )}
    </VStack>
  )
}
